import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const categoryAdd = createAsyncThunk(
  "category/categoryAdd",
  async ({ name, image, sellerId }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("image", image);
      formData.append("sellerId", sellerId);
      const { data } = await api.post("/category-add", formData, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const get_category = createAsyncThunk(
  "category/get_category",
  async (
    { parPage, page, searchValue, sellerId },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
       const { data } = await api.get(
         `/category-get?page=${page}&searchValue=${searchValue}&parPage=${parPage}&sellerId=${sellerId}`,
         { withCredentials: true }
       );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// New delete category thunk
export const delete_category = createAsyncThunk(
  "category/delete_category",
  async (categoryId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.delete(`/category-delete/${categoryId}`, {
        withCredentials: true,
      });
      return fulfillWithValue({ data, categoryId });
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Add update category thunk
export const update_category = createAsyncThunk(
  "category/update_category",
  async ({ name, image, sellerId, categoryId }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("name", name);
      if (image) {
        formData.append("image", image);
      }
      formData.append("sellerId", sellerId);
      formData.append("categoryId", categoryId);
      
      const { data } = await api.put("/category-update", formData, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return fulfillWithValue(data);
    } catch (error) {
      // console.log('Update Category Error:', error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const categoryReducer = createSlice({
  name: "category",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    categorys: [],
    totalCategory: 0,
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: {
    [categoryAdd.pending]: (state, _) => {
      state.loader = true;
    },
    [categoryAdd.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.error;
    },
    [categoryAdd.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.categorys = [...state.categorys, payload.category];
    },
    [get_category.fulfilled]: (state, { payload }) => {
      state.totalCategory = payload.totalCategory;
      state.categorys = payload.categorys;
    },
    // New delete category reducers
    [delete_category.pending]: (state, _) => {
      state.loader = true;
    },
    [delete_category.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.error;
    },
    [delete_category.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.data.message;
      state.categorys = state.categorys.filter(
        (category) => category._id !== payload.categoryId
      );
      state.totalCategory = state.totalCategory - 1;
    },
    // Add update category reducers
    [update_category.pending]: (state, _) => {
      state.loader = true;
    },
    [update_category.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.error;
    },
    [update_category.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.categorys = state.categorys.map(category => 
        category._id === payload.category._id ? payload.category : category
      );
    },
  },
});

export const { messageClear } = categoryReducer.actions;
export default categoryReducer.reducer;
